import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ClinicLayoutComponent, type ClinicMenuItem } from '@dental-ui/clinic-layout';
import { CLINIC_MENU_ITEMS } from '@dental-ui/shared/consts';

@Component({
  selector: 'app-clinic-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ClinicLayoutComponent],
  template: `
    <lib-clinic-layout
      [menuItems]="menuItems"
      appTitle="Clinic Manager"
    >
      <router-outlet />
    </lib-clinic-layout>
  `,
})
export class ClinicShellComponent {
  menuItems: ClinicMenuItem[] = CLINIC_MENU_ITEMS;
}
// touch
